import { Link, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSEO } from "@/lib/use-seo";

const SUGGESTIONS = [
  { to: "/curriculum", label: "Curriculum" },
  { to: "/workshops", label: "Free workshops" },
  { to: "/membership", label: "Membership" },
  { to: "/contact", label: "Contact us" },
];

const NotFound = () => {
  const { pathname } = useLocation();

  useSEO({
    title: "Page not found",
    description:
      "That page doesn't exist. Browse the curriculum, workshops, or membership options instead.",
    path: "/404",
    noindex: true,
  });

  return (
    <div className="min-h-[70vh] flex items-center bg-background pt-28 pb-16">
      <div className="section-inner max-w-xl text-center">
        <Compass className="w-12 h-12 text-primary mx-auto mb-6" aria-hidden="true" />
        <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-3">
          404
        </p>
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          We couldn&apos;t find that page
        </h1>
        <p className="text-base text-foreground/80 mb-8 leading-relaxed">
          <span className="font-mono break-all">{pathname}</span> doesn&apos;t
          exist &mdash; it may have moved or the link may be mistyped. Try one of
          these instead.
        </p>
        <nav className="flex flex-wrap gap-3 justify-center mb-8" aria-label="Suggested pages">
          {SUGGESTIONS.map((s) => (
            <Button key={s.to} asChild variant="outline">
              <Link to={s.to}>{s.label}</Link>
            </Button>
          ))}
        </nav>
        <Button asChild size="lg">
          <Link to="/">Back to home</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
